import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles(() => ({
  dialogContent: {
    width: '300px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  dialogTitle: {
    textAlign: 'center',
    padding: '12px 0 0 0',
    '& .MuiTypography-h6': {
      fontSize: '16px',
      fontWeight: 'bold'
    }
  }
}))